import React from 'react'
import ReactDOM from 'react-dom/client'

import '@/common/polyfill'
import 'antd-mobile/es/global'
import './index.scss'

import App from './App'

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
)

root.render(<App />)

if (process.env.NODE_ENV === 'production') {
    // @ts-ignore
    Raven && Raven.config('https://bb1b2caf13734cf1b8aff5ac24241b24@bug-xl9-ssl.xunlei.com/42').install()
}
